/**
 * <s-floating-contact> — Keeps the floating WhatsApp button from covering
 * content at the end of the page: while the footer (which repeats the WhatsApp
 * link) is on screen, the button fades out and becomes inert.
 *
 * Attributes:
 *   data-avoid — CSS selector of the element to stay clear of (default: "footer").
 * State:
 *   [data-hidden] — present while the button is tucked away (CSS owns the motion).
 */
class SFloatingContact extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector(this.dataset.avoid || 'footer');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      this.toggleAttribute('data-hidden', entry.isIntersecting);
      this.inert = entry.isIntersecting;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-floating-contact')) customElements.define('s-floating-contact', SFloatingContact);
